const config = {
  base_url: 'https://api.onboarding.tenacy.io/',
};

export default config;
